import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Model from 'flarum/common/Model';
export default class BolillaClassification extends Model {
  constructor() {
    super(...arguments);
    _defineProperty(this, "userId", Model.attribute('userId'));
    _defineProperty(this, "totalPoints", Model.attribute('totalPoints'));
    _defineProperty(this, "matchesVoted", Model.attribute('matchesVoted'));
    _defineProperty(this, "user", Model.hasOne('user'));
  }
}
flarum.reg.add('nagusi-match-ratings', 'common/models/BolillaClassification', BolillaClassification);